// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgArchedArrowRightIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M3.29 11.29c3.97-3.97 10.44-3.97 14.41 0l1.29 1.29V9c0-.55.45-1 1-1S21 8.45 21 9v6a1.02 1.02 0 0 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1h3.59l-1.29-1.29c-3.2-3.19-8.39-3.19-11.59 0-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41z" />
  </g>
);
export default SvgArchedArrowRightIcon;
SvgArchedArrowRightIcon.displayName = 'SvgArchedArrowRightIcon';
